import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Box, IconButton, Tooltip } from "@mui/material";
import { createMRTColumnHelper } from "material-react-table";
import { toast } from "react-toastify";
import { ContentCopy } from "@mui/icons-material";
import CustomTable from "../../components/customTable/CustomTable";
import { partnerClient } from "../../app/slices/partnerInvoice/partnerTransactionSlice";

export default function Mfd({ partnerUsername }) {
  const dispatch = useDispatch();
  const [mfds, setMfds] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!partnerUsername) return;

    const fetchMfds = async () => {
      setLoading(true);
      try {
        const response = await dispatch(
          partnerClient({ partnerUsername, type: "mfd" }),
        );
        // console.log(response, "responsenautiyal");
        if (response.meta.requestStatus === "fulfilled") {
          setMfds(response.payload.data || []);
        }
      } catch (error) {
        console.log("error fetching MFDs: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMfds();
  }, [partnerUsername, dispatch]);

  // Same field shape assumed as the Client response — adjust if MFD records differ
  const sliceResponse =
    mfds.length > 0 &&
    mfds?.map((item) => ({
      id: item?._id || "-",
      name: item?.name || "-",
      username: item?.username || "-",
      email: item?.Email || "-",
      mobileNo: item?.PhoneNo || "-",
      partnerUsername: item?.partner_username || "-",
      panNumber: item?.panNo || "-",
      mmtcCommission: item?.mmtc_commission || "-",
      Augmontcommission: item?.commission || "-",
      dob: item?.dob || "-",
      addressLine1: item?.address || "-",
      city: item?.city || "-",
      state: item?.state || "-",
      pincode: item?.pincode || "-",
      createdAt: item?.createdAt || "-",
      updatedAt: item?.updatedAt || "-",
    }));

  const makeCopyableColumn = (columnHelper, accessorKey, header, size = 30) =>
    columnHelper.accessor(accessorKey, {
      header,
      size,
      Cell: ({ cell }) => {
        const value = cell.row.original[accessorKey];
        const handleCopy = () => {
          navigator.clipboard.writeText(value ?? "");
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={value || "N/A"}>
            <span>
              <IconButton onClick={handleCopy} size="small">
                <ContentCopy fontSize="inherit" />
              </IconButton>
              {value}
            </span>
          </Tooltip>
        );
      },
    });

  const columnHelper = createMRTColumnHelper();
  const columns = [
    makeCopyableColumn(columnHelper, "id", "ID"),
    columnHelper.accessor("name", { header: "Name", size: 30 }),
    columnHelper.accessor("username", { header: "MFD UserName", size: 30 }),
    columnHelper.accessor("email", { header: "Email", size: 30 }),
    columnHelper.accessor("mobileNo", { header: "Mobile No", size: 30 }),
    columnHelper.accessor("panNumber", { header: "PAN Number", size: 30 }),
    columnHelper.accessor("mmtcCommission", {
      header: "MMTC Commission",
      size: 30,
    }),
    columnHelper.accessor("Augmontcommission", {
      header: "Augmont Commission",
      size: 30,
    }),
    columnHelper.accessor("dob", { header: "DOB", size: 30 }),
    columnHelper.accessor("addressLine1", {
      header: "Address Line 1",
      size: 30,
    }),
    columnHelper.accessor("city", { header: "City", size: 30 }),
    columnHelper.accessor("state", { header: "State", size: 30 }),
    columnHelper.accessor("pincode", { header: "Pincode", size: 30 }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: ({ cell }) => cell?.row?.original?.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: ({ cell }) => cell?.row?.original?.updatedAt?.split("T")[0],
    }),
  ];

  return (
    <Box mt={2}>
      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={loading}
        permissionKey="PartnerSubPartner"
      />
    </Box>
  );
}
